"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _reactSelect = _interopRequireWildcard(require("react-select"));

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _icon = _interopRequireDefault(require("../../icon"));

var _dropdown = require("../dropdown");

var _constants = require("../../../assets/js/constants");

var _templateObject, _templateObject2, _templateObject3, _templateObject4;

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _taggedTemplateLiteral(strings, raw) { if (!raw) { raw = strings.slice(0); } return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }

var ControlTitle = _styledComponents["default"].div.withConfig({
  displayName: "titleSelect__ControlTitle",
  componentId: "sc-1ebhv12-0"
})(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n    cursor: pointer;\n"])));

var Control = function Control(props) {
  var children = props.children,
      isDisabled = props.isDisabled,
      isFocused = props.isFocused,
      innerRef = props.innerRef,
      innerProps = props.innerProps;
  return /*#__PURE__*/_react["default"].createElement(ControlTitle, _extends({
    ref: innerRef,
    isFocused: isFocused,
    isDisabled: isDisabled
  }, innerProps), children);
};

var ValueContainer = (0, _styledComponents["default"])(_reactSelect.components.ValueContainer).withConfig({
  displayName: "titleSelect__ValueContainer",
  componentId: "sc-1ebhv12-1"
})(_templateObject2 || (_templateObject2 = _taggedTemplateLiteral(["\n    padding: 0!important;\n    flex: auto!important;\n    align-items: flex-start!important;\n"])));

var TitleValue = _styledComponents["default"].div.withConfig({
  displayName: "titleSelect__TitleValue",
  componentId: "sc-1ebhv12-2"
})(_templateObject3 || (_templateObject3 = _taggedTemplateLiteral(["\n    color: ", ";\n"])), _constants.COLORS.blue);

var SingleValue = function SingleValue(props) {
  var children = props.children,
      isDisabled = props.isDisabled,
      innerRef = props.innerRef,
      innerProps = props.innerProps;
  return /*#__PURE__*/_react["default"].createElement(TitleValue, _extends({
    ref: innerRef,
    isDisabled: isDisabled
  }, innerProps), children);
};

var Indicator = (0, _styledComponents["default"])(_reactSelect.components.DropdownIndicator).withConfig({
  displayName: "titleSelect__Indicator",
  componentId: "sc-1ebhv12-3"
})(_templateObject4 || (_templateObject4 = _taggedTemplateLiteral(["\n    min-width: 20px;\n    justify-content: center;\n    align-items: center;\n    margin-left: 5px;\n    padding: 0!important;\n"])));

var DropdownIndicator = function DropdownIndicator(props) {
  return /*#__PURE__*/_react["default"].createElement(Indicator, props, /*#__PURE__*/_react["default"].createElement(_icon["default"], {
    content: "\\e653",
    color: _constants.COLORS.blue
  }));
};

var Select = /*#__PURE__*/function (_React$Component) {
  _inherits(Select, _React$Component);

  var _super = _createSuper(Select);

  function Select() {
    var _this;

    _classCallCheck(this, Select);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _super.call.apply(_super, [this].concat(args));

    _defineProperty(_assertThisInitialized(_this), "onChange", function (value) {
      _this.props.onChange(value);
    });

    return _this;
  }

  _createClass(Select, [{
    key: "render",
    value: function render() {
      var _this$props = this.props,
          options = _this$props.options,
          defaultValue = _this$props.defaultValue,
          value = _this$props.value,
          placeholder = _this$props.placeholder,
          minWidth = _this$props.minWidth,
          extStyle = _this$props.extStyle,
          smallOption = _this$props.smallOption,
          rest = _objectWithoutProperties(_this$props, ["options", "defaultValue", "value", "placeholder", "minWidth", "extStyle", "smallOption"]);

      var Option = function Option(props) {
        return smallOption ? /*#__PURE__*/_react["default"].createElement(_dropdown.SmallOption, _extends({
          fontSize: "14px"
        }, props)) : /*#__PURE__*/_react["default"].createElement(_dropdown.Option, props);
      };

      var customComponents = {
        IndicatorSeparator: null,
        Control: Control,
        ValueContainer: ValueContainer,
        SingleValue: SingleValue,
        Option: Option,
        Menu: _dropdown.Menu,
        MenuList: _dropdown.MenuList,
        DropdownIndicator: DropdownIndicator
      };

      var customStyles = _objectSpread({
        menu: function menu(base) {
          return _objectSpread(_objectSpread({}, base), {}, {
            minWidth: minWidth
          });
        }
      }, extStyle);

      return /*#__PURE__*/_react["default"].createElement(_reactSelect["default"], _extends({
        options: options,
        onChange: this.onChange,
        defaultValue: defaultValue,
        value: value,
        isClearable: false,
        isSearchable: false,
        placeholder: placeholder,
        components: customComponents,
        styles: customStyles
      }, rest));
    }
  }]);

  return Select;
}(_react["default"].Component);

exports["default"] = Select;

_defineProperty(Select, "propTypes", {
  options: _propTypes["default"].arrayOf(_propTypes["default"].shape({
    label: _propTypes["default"].any,
    value: _propTypes["default"].any
  })),
  defaultValue: _propTypes["default"].any,
  placeholder: _propTypes["default"].string,
  onChange: _propTypes["default"].func,
  value: _propTypes["default"].shape({
    label: _propTypes["default"].any,
    value: _propTypes["default"].any
  })
});

_defineProperty(Select, "defaultProps", {
  options: [],
  placeholder: '',
  onChange: function onChange() {}
});